import { notifications } from '@mantine/notifications'
import { handleMutationError } from '@v2/commons/utils/errorHandling/handleMutationError'

import {
  useAddChatMessageMutation,
  useGetChatMessagesQuery,
} from '../api/chat.api'

const useChatMessages = (chatId: string) => {
  const { data, isError, isLoading, isSuccess } =
    useGetChatMessagesQuery(chatId)

  const [addChatMessage, addChatMessageMutationStatus] =
    useAddChatMessageMutation()

  const onAddNote = (content: string) => {
    addChatMessage({
      data: {
        chatId: chatId,
        message: content,
      },
    })
      .unwrap()
      .then(() =>
        notifications.show({
          title: 'Success',
          message: 'Successfully added a new note to chat',
          color: 'blue',
        }),
      )
      .catch((error) =>
        handleMutationError(error, 'Failed to create a new note!'),
      )
  }

  return {
    messages: data?.records?.filter(({ message }) => !!message),
    addChatMessage,
    addChatMessageMutationStatus,
    getMessagesStatus: {
      isError,
      isLoading,
      isSuccess,
    },
    isGetMessagesError: isError,
    onAddNote,
  }
}

export default useChatMessages
